<ng-template #editProfileTemplate>
        <div class="modal-header">
                <h5 class="modal-title">{{ 'pg-edit-profile.title-edit-profile' | locTranslate }}</h5>
                <button type="button" class="btn-close" aria-label="Close" (click)="closeEditor()"></button>
        </div>
        <div class="modal-body">
                <app-pg-profile-editor (onSave)="closeEditor()"></app-pg-profile-editor>
        </div>
</ng-template>
